// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FullscreenOutlinedSvg from "@ant-design/icons-svg/es/asn/FullscreenOutlined";
import AntdIcon from '../components/AntdIcon';

var FullscreenOutlined = function FullscreenOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenOutlinedSvg
  }));
};

FullscreenOutlined.displayName = 'FullscreenOutlined';
export default React.forwardRef(FullscreenOutlined);